import { makeRequest } from 'utils/requestLogger';

export default (id) =>
    makeRequest('get', `/api/votes/${id}`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getPollVote.js